import { getLocale } from "../runtime";

const sv_price = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Pris`
};

const price = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_price(inputs)
	return "price";
};

export { price as "price" };